import { Env, readFromEnv } from '@cinch-nx/environments'

export const getNaturalLanguageQueryFromUrlPath = (
  urlPath: string,
): string | null => {
  const isNaturalLanguageSearchEnabled =
    readFromEnv(Env.EnableNaturalLanguageSearch) === 'true'

  if (!isNaturalLanguageSearchEnabled) {
    return null
  }

  const urlWithoutLeadingSlash = urlPath.startsWith('/')
    ? urlPath.slice(1)
    : urlPath

  return new URLSearchParams(urlWithoutLeadingSlash.split('?')[1]).get('q')
}
